import { Component, Prop, h } from '@stencil/core';
import { FontSize, StrokeWidth } from '../types';
import { IconProps } from './types';

@Component({
  shadow: true,
  styleUrl: 'icon.css',
  tag: 'abds-icon',
})
export class Icon implements IconProps {
  // --------------------------------------------------------------------------
  //
  //  Props
  //
  // --------------------------------------------------------------------------

  /** Sets abds-icon to display.  */
  @Prop({ reflect: true }) icon!: string;

  /** Sets icon size. */
  @Prop({ reflect: true }) size: FontSize = 'base';

  /** Sets icon stroke-width. */
  @Prop({ reflect: true }) strokeWidth: StrokeWidth = 'regular';

  // --------------------------------------------------------------------------
  //
  //  Lifecycle Methods
  //
  // --------------------------------------------------------------------------

  render() {
    const El = `abds-icon-${this.icon}`;

    return <El size={this.size} stroke-width={this.strokeWidth} />;
  }
}
